// Mixins
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';
import { tableMixins } from '@/app/mixins/utils/table-mixins.js';
import { userMixins } from '@/app/mixins/modules/user-mixins.js';

// Components
const MemberTableComponent = () => import(/* webpackPrefetch: true, webpackChunkName: "member-table-component"*/ '@/app/views/main-view/social-club/components/member-table-component/member-table-component.vue');

// Services
import ClubService from '@/app/services/main/club/club-service.js';

// Third Party libraries
import * as $ from 'jquery';

// Constants
import { STATUS_CODES } from '@/app/constants/status-constants';

export default {
	name: 'ModalSocialTransferPrimaryAdmin',
	components: {
		MemberTableComponent
	},
	mixins: [
		toastMessageMixins,
		tableMixins,
		userMixins
	],
	data() {
		return {
			isAPILoading: false,
			searchMember: '',
			membersThatAreNotActive: [],
			isGetMembersLoading: false,
			desc: true
		}
	},
	beforeDestroy() {
		this.closeModal();
	},
	methods: {
		openModal() {
			$(this.$refs.transferPrimaryAdmin).modal('show');
			this.searchMember = '';
			this.columnsFilter = {};
			this.getTableContent();
		},
		closeModal() {
			$(this.$refs.transferPrimaryAdmin).modal('hide');
		},
		transferPrimaryAdmin(customerId) {
			this.$emit('transferPrimaryAdmin', customerId);
		},
		getTableContent(fromFilter, page = this.page, limit = this.limit, sortBy = this.sortBy, desc = this.desc) {

			page = fromFilter ? 1 : this.page;
			
			this.getMembersList({ page, limit, sortBy, desc });
		},
		getMembersList(queryParams) {
			this.isGetMembersLoading = true;

			queryParams.f_groupId = this.$store.getters.getActiveGroup.id;
			queryParams.f_status = 'ACTIVE';
			queryParams.f_user = this.userDetails.customerId;

			if (this.columnsFilter) {
				if (this.columnsFilter.f_name) {
					queryParams['f_name'] = this.columnsFilter.f_name; 
				}
			}
			
			// Call API service to get the table content
			ClubService.getAllGroupMembers(queryParams)
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.tableContent = {
							tableData: res.data.data,
							paginationData: res.data.pagination
						};
						
						this.isGetMembersLoading = false;
					} else {
						const { ERROR_GET_REPORTED_LIST } = this.toastMessages.report();
						this.showAPIErrorToast(ERROR_GET_REPORTED_LIST, res);
					}

					this.isGetMembersLoading = false;
				})
				.catch(() => {
					this.showGenericErrorToast();
					this.isGetMembersLoading = false;
				});
		}
	}
}